import React, { useMemo } from 'react';
import TextLink from 'components/TextLink';
import { useFetchMyAsset } from 'actions/assets';
import { getAdminDownloadUrl } from 'utils/asset/getDownloadUrl';
export default function AssetDownloadLink(_ref) {
  var assetId = _ref.assetId,
    children = _ref.children;
  var _useFetchMyAsset = useFetchMyAsset({
      id: assetId
    }),
    asset = _useFetchMyAsset.data;
  var downloadUrl = useMemo(function () {
    return getAdminDownloadUrl(asset);
  }, [asset]);
  if (!downloadUrl) {
    return children;
  }
  return /*#__PURE__*/React.createElement(TextLink, {
    as: "a",
    href: downloadUrl
  }, children);
}